/** @format */

export const carSides = [
  { text: 'Lato passegero', value: 'Destro' },
  { text: 'Lato guidatore', value: 'Sinistro' },
  { text: 'Anteriore', value: 'Anteriore' },
  { text: 'Posteriore', value: 'Posteriore' },
  { text: 'Anteriore/Lato passegero', value: 'Anteriore/Destro' },
  { text: 'Anteriore/Lato guidatore', value: 'Anteriore/Sinistro' },
  { text: 'Posteriore/Lato passegero', value: 'Posteriore/Destro' },
  { text: 'Posteriore/Lato guidatore', value: 'Posteriore/Sinistro' },
];
